import Cart from "./cart"
import CartPage from "./cart-page"
import API from "../api"

(window as any).API = API;
(window as any).GA4Items = []

const isCartPage = window.location.pathname.includes("cart");

if (isCartPage) {
    (window as any).CartPage = CartPage;
    $(() => CartPage.onPageLoad())
} else {
    (window as any).Cart = Cart;
    $(() => Cart.onPageLoad())
}
